import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function TermsPage() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <div className="min-h-screen bg-background-50">
      {/* Page Header */}
      <section className="relative py-20 md:py-28 px-4 lg:px-8 bg-background-100 rounded-3xl mx-4 lg:mx-8 mt-4 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dark%20charcoal%20background%20with%20warm%20golden%20contract%20and%20document%20motif%20lines%2C%20elegant%20legal%20corporate%20aesthetic%2C%20gold%20highlights%20on%20deep%20black%2C%20sophisticated%20minimal%20style%2C%20soft%20gradient%20tones%2C%20no%20text&width=1600&height=500&seq=terms-header-001&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/15" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center px-3 py-1.5 rounded-md bg-primary-100 mb-6">
            <span className="text-primary-700 text-xs font-bold uppercase tracking-wider">
              法務情報
            </span>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            利用規約
          </h1>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            最終更新日: 2026年6月1日
          </p>
        </div>
      </section>

      {/* Content */}
      <section
        ref={ref}
        className={`py-16 md:py-20 px-4 lg:px-8 animate-on-scroll ${
          isVisible ? "is-visible" : ""
        }`}
      >
        <div className="max-w-4xl mx-auto">
          <article className="space-y-10">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                第1条（適用範囲）
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                本服务条款（以下「本条款」）は、株式会社銀行データカード（以下「当社」）が提供する
                金融データ処理サービスおよび関連ソリューション（以下「本サービス」）の利用に関する条件を
                定めるものです。本サービスをご利用いただくお客様（以下「利用者」）は、
                本条款に同意したものとみなされます。
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                第2条（サービスの内容）
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed mb-3">
                当社は、利用者に対して以下のサービスを提供します：
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li className="text-foreground-600 text-base">
                  カード決済データの高速処理および分析サービス
                </li>
                <li className="text-foreground-600 text-base">
                  金融データの暗号化およびセキュアな保管
                </li>
                <li className="text-foreground-600 text-base">
                  コンプライアンス関連の監査およびレポート作成支援
                </li>
                <li className="text-foreground-600 text-base">
                  API連携によるシステム統合サポート
                </li>
                <li className="text-foreground-600 text-base">
                  テクニカルサポートおよびコンサルティング
                </li>
              </ul>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                第3条（利用契約の成立）
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                利用契約は、利用者が当社所定の申込手続きを完了し、
                当社がこれを承諾した時点で成立するものとします。
                当社は、以下のいずれかに該当する場合、申込みを承諾しないことがあります：
                申込内容に虚偽の記載がある場合、過去に本条款に違反したことがある場合、
                または当社が不適切と判断した場合。
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                第4条（利用料金）
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                本サービスの利用料金は、当社が別途定める料金表に基づきます。
                利用者は、当社が指定する支払方法により、請求書発行日から30日以内に
                利用料金をお支払いいただきます。支払遅延の場合、年率14.6%の遅延損害金が発生します。
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                第5条（禁止事項）
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed mb-3">
                利用者は、以下の行為を行ってはなりません：
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li className="text-foreground-600 text-base">
                  本サービスを不正な目的で利用する行為
                </li>
                <li className="text-foreground-600 text-base">
                  他の利用者または第三者の権利を侵害する行為
                </li>
                <li className="text-foreground-600 text-base">
                  本サービスの運営を妨害する行為
                </li>
                <li className="text-foreground-600 text-base">
                  当社のシステムに不正アクセスする行為
                </li>
                <li className="text-foreground-600 text-base">
                  法令または公序良俗に反する行為
                </li>
              </ul>
            </div>

            {/* Section 6 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                第6条（免責事項）
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                当社は、本サービスの利用により発生した損害について、
                当社の故意または重過失による場合を除き、一切の責任を負いません。
                天災、停電、通信回線の障害など、当社の合理的な管理範囲を超える事由により
                サービスが中断した場合も同様とします。
              </p>
            </div>

            {/* Section 7 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                第7条（機密保持）
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                当社および利用者は、本サービスの利用に関して知り得た相手方の技術上、
                営業上その他一切の情報を、相手方の事前の書面による承諾なく第三者に開示、
                漏洩してはなりません。この機密保持義務は、契約終了後も3年間継続するものとします。
              </p>
            </div>

            {/* Section 8 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                第8条（契約期間および解約）
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                利用契約の期間は契約締結日から1年間とし、期間満了の3ヶ月前までに
                いずれかから解約の申し出がない限り、同一条件でさらに1年間自動更新されます。
                利用者は、30日前の書面による通知により、いつでも解約することができます。
                当社は、利用者が本条款に違反した場合、即時に契約を解除できるものとします。
              </p>
            </div>

            {/* Section 9 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                第9条（条款の変更）
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                当社は、必要に応じて本条款を変更することができます。
                変更後の条款は、当社ウェブサイトに掲載した時点から効力を生じるものとします。
                重要な変更がある場合は、利用者に対して事前に通知いたします。
              </p>
            </div>

            {/* Section 10 */}
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 mb-4">
                第10条（準拠法および管轄裁判所）
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed">
                本条款の解釈および適用は、日本国法に準拠するものとします。
                本条款に関して紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
              </p>
            </div>

            {/* Contact Box */}
            <div className="p-5 rounded-xl bg-background-100">
              <p className="text-foreground-950 font-medium text-sm mb-2">
                お問い合わせ
              </p>
              <p className="text-foreground-600 text-sm">
                本条款に関するご質問は、admin@bankcheckdata-card.jp までご連絡ください。
              </p>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
}